import { configureAndInitializeAmplify } from '@modules/authentication/utils/configureAndInitializeAmplify';
import { FormEvent, useCallback, useContext, useState } from 'react';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { AuthContext } from 'v2/core/clients/authAmplify';
import { AuthErrorCode, toAuthError } from 'v2/core/services/auth/errors';
import { getAuthErrorMessage } from './utils';

const trackSignInEvent = createAnalyticsTracker('signIn');

interface SignInInput {
  email: string;
  password: string;
  onSuccess?: () => void;
  onError?: () => void;
  onUserNotConfirmedError?: () => void;
}

const useSignIn = ({
  email,
  password,
  onSuccess,
  onError,
  onUserNotConfirmedError,
}: SignInInput) => {
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const auth = useContext(AuthContext);

  const signIn = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      setLoader(true);
      configureAndInitializeAmplify();
      try {
        await auth.signIn({ email, password });
        onSuccess?.();
        trackSignInEvent({ eventName: 'Sign In with Email CTA' });
      } catch (err: unknown) {
        const error = toAuthError(err);
        const errorMessage = getAuthErrorMessage(error);
        setErrorMessage(errorMessage);
        if (error.code === AuthErrorCode.UserNotConfirmedException) {
          onError?.();
          onUserNotConfirmedError?.();
        }
      }

      setLoader(false);
    },
    [email, auth, password, onSuccess, onError, onUserNotConfirmedError],
  );
  return { signIn, loader, errorMessage };
};

export default useSignIn;
